import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { TicketService } from '@/modules/ticket/services/ticket.service'
import { TicketStoreRequestModel } from '@/modules/ticket/models/ticket-request.model'

@vservice()
export class StoreTicketUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: TicketService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(data: TicketStoreRequestModel) {
    return this.service.storeTicket(data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
